import { render, staticRenderFns } from "./AppointmentClientPostcodePage.vue?vue&type=template&id=d4d45818"
import script from "./AppointmentClientPostcodePage.vue?vue&type=script&lang=ts"
export * from "./AppointmentClientPostcodePage.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentClientPostcodePage.vue?vue&type=style&index=0&id=d4d45818&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports